import { Divider } from 'common/ui/divider';
import { Faqs, Pros } from 'context/page-form-context';
import { AiVariantComment, AiVariantContext } from 'modules/mel-ai/types';
import { UseFormReturn } from 'react-hook-form';

import { ContextHistory } from '../context-history';
import styles from './content-map.module.scss';
import { FaqsContentMap } from './faqs-content-map';
import { ProsContentMap } from './pros-content-map';

interface ContentMapProps {
  contextHistory: AiVariantComment[];
  form: UseFormReturn<AiVariantContext, any>;
  originalContent: string | Faqs | Pros;
  isFaqs?: boolean;
  isPros?: boolean;
  isString?: boolean;
}

const ContentMap = ({
  contextHistory,
  form,
  isFaqs,
  isPros,
  isString,
  originalContent,
}: ContentMapProps) => {
  const { register } = form;

  return (
    <div className={styles.container}>
      <div className={styles.orininalContent}>
        <h5 className={styles.title}>Original Content</h5>
        <Divider />
        <div className={styles.content}>
          {isString && <p>{originalContent as string}</p>}
          {isPros && <ProsContentMap pros={originalContent as Pros} />}
          {isFaqs && <FaqsContentMap faqs={originalContent as Faqs} />}
        </div>
      </div>
      <div className={styles.contextHistory}>
        <h5 className={styles.title}>Context History</h5>
        <Divider />
        <div className={styles.history}>
          <ContextHistory contextHistory={contextHistory} />
        </div>
      </div>
      <div className={styles.contextField}>
        <h5 className={styles.title}>Regeneration Context</h5>
        <Divider />
        <div className={styles.field}>
          <textarea
            placeholder="Regeneration context (optional)..."
            style={{ height: '100%', width: '100%' }}
            {...register('context')}
          />
        </div>
      </div>
    </div>
  );
};

export { ContentMap };
